/** Shared table header styling for bulk invoice wizard steps (matches primary table headers) */
export const bulkInvoiceTableSeparatorSx = {
  mx: 2,
  borderColor: 'grey.300',
}

export const bulkInvoiceTableHeaderSx = {
  fontWeight: 600,
  color: 'primary.contrastText',
  backgroundColor: 'primary.main',
  borderBottom: '1px solid',
  borderColor: 'rgba(255, 255, 255, 0.2)',
  borderLeft: 'none',
  borderRight: 'none',
  boxShadow: 'none',
  '&.MuiTableCell-stickyHeader': {
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
    boxShadow: 'none',
  },
}

export const bulkInvoiceTableHeaderCheckboxSx = {
  py: 0,
  color: 'rgba(255, 255, 255, 0.75)',
  '&.Mui-checked': {
    color: 'common.white',
  },
  '&.MuiCheckbox-indeterminate': {
    color: 'common.white',
  },
}
